// extracted by mini-css-extract-plugin
export var ecgline = "preloader-module--ecgline--2laZN";
export var ekg = "preloader-module--ekg--E0QGO";
export var heartbeat = "preloader-module--heartbeat--GQWjd";
export var hidden = "preloader-module--hidden--A2Eg1";
export var inContent = "preloader-module--in-content--veyA+";
export var load_conainer = "preloader-module--load_conainer--j7mS1";
export var preloader = "preloader-module--preloader--sbKGg";
export var preloader_logo = "preloader-module--preloader_logo--Ve7yU";